/* eslint-disable */
window.BlockMap = () => {
    return {

    }
}
/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/blocks/Map.js